import { Observable, of, bindCallback, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { toGoogleGeocoderRequest } from '../helpers';
import { IGoogleGeocoderRequest } from '../interfaces';
import { SnGoogleGeocoderResult } from '../models';

@Injectable()
export class SnGoogleGeocoderService {
  private readonly _geocoder: google.maps.Geocoder;

  constructor() {
    this._geocoder = new google.maps.Geocoder();
  }

  public geocode(request: IGoogleGeocoderRequest): Observable<SnGoogleGeocoderResult[]> {
    const geocoder = bindCallback(this._geocoder.geocode);
    const geocoderRequest = toGoogleGeocoderRequest(request);

    return geocoder(geocoderRequest).pipe(
      switchMap(([results, status]) => {
        return status === google.maps.GeocoderStatus.OK ? of(results) : throwError(status);
      }),
      map((results: google.maps.GeocoderResult[]) => {
        return results.map((res) => new SnGoogleGeocoderResult(res));
      }),
    );
  }
}
